import { BaseDataService } from './BaseDataService';
import { Characteristic, CharacteristicGroup, SurveyVersion, Survey } from '../../models';
import { NotificationService } from '../../services';

export class CharacteristicDataService extends BaseDataService<Characteristic> {
    constructor(notificationService: NotificationService) {
        super('Characteristic', 'Characteristics', notificationService);
    }

    public getAllByGroup(group: CharacteristicGroup): Promise<any> {
        const endpoint = `${this.endpointRoot}/ByGroup/${group.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characterisics.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllBySurvey(survey: Survey): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurvey/${survey.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic groups.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristics`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/CharacteristicData.tsx